<oph-delete-dialog-content
  [message]="message"
  (close)="onClose($event)"
  [loading]="loading"
></oph-delete-dialog-content>
